export function stripLeadingFeaturedImage(
  content: string | null | undefined,
  featuredImageUrl: string | null | undefined,
): string {
  if (!content) return '';
  if (!featuredImageUrl) return content;

  const trimmed = content.trimStart();
  if (!trimmed.startsWith('![') && !trimmed.startsWith('[![')) return content;

  const newlineAt = trimmed.indexOf('\n');
  if (newlineAt === -1) return '';
  return trimmed.slice(newlineAt + 1).trimStart();
}
